import styled, { keyframes } from "styled-components";
import React from "react";
import { useTranslation } from "react-i18next";
type LoadingSpinnerProps = {
  className?: string;
  colour?: string;
};
const SpinnerGradient = styled.div<{
  colour?: string;
}>`
  width: 24px;
  height: 24px;
  background: conic-gradient(
    #0000,
    ${({
  colour,
  theme
}) => colour ?? theme.colours.dark}
  );
`;
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Svg = styled.svg`
  animation: ${rotate} 0.75s linear infinite;
`;
export function LoadingSpinnerSvg({
  colour,
  className,
  title
}: LoadingSpinnerProps & {
  title: string;
}) {
  return <Svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" role="img" data-sentry-element="Svg" data-sentry-component="LoadingSpinnerSvg" data-sentry-source-file="LoadingSpinner.tsx">
      <title>{title}</title>

      <clipPath id="clip" data-sentry-element="clipPath" data-sentry-source-file="LoadingSpinner.tsx">
        <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM4.75695 12C4.75695 16.0002 7.99978 19.243 12 19.243C16.0002 19.243 19.243 16.0002 19.243 12C19.243 7.99978 16.0002 4.75695 12 4.75695C7.99978 4.75695 4.75695 7.99978 4.75695 12Z" data-sentry-element="path" data-sentry-source-file="LoadingSpinner.tsx" />
      </clipPath>

      <foreignObject x="0" y="0" width="24" height="24" clipPath="url(#clip)" data-sentry-element="foreignObject" data-sentry-source-file="LoadingSpinner.tsx">
        <SpinnerGradient colour={colour} data-sentry-element="SpinnerGradient" data-sentry-source-file="LoadingSpinner.tsx" />
      </foreignObject>
    </Svg>;
}
export function LoadingSpinner({
  colour,
  className
}: LoadingSpinnerProps) {
  const {
    t
  } = useTranslation();
  const title = t("loading");
  return <LoadingSpinnerSvg {...{
    className,
    colour,
    title
  }} data-sentry-element="LoadingSpinnerSvg" data-sentry-component="LoadingSpinner" data-sentry-source-file="LoadingSpinner.tsx" />;
}
export default LoadingSpinner;